import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogActions, DialogContent, Typography, Button, Checkbox, FormControlLabel, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import InputField from './InputField';
import { useRecoilValue } from 'recoil';
import { selectedDps } from '../../../atoms/DspState';
import { toast } from 'react-toastify';

ResetPassword.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  handleApprove: PropTypes.func.isRequired,
  labelCancel: PropTypes.string,
  labelApprove: PropTypes.string,
  content: PropTypes.string.isRequired,
  infos: PropTypes.object,
};

const useStyles = makeStyles()((theme) => ({
  Root: {
    '& .MuiDialog-paper': {
      margin: theme.spacing(2, 4),
    },
  },
  CancelBtn: {
    margin: theme.spacing(1),
    border: '1px solid #989798 !important',
    color: '#989798',
  },
  ApproveBtn: {
    margin: theme.spacing(1),
    backgroundColor: '#75c31e !important',
    color: '#fff !important',
  },
  Title: {
    fontWeight: 600,
    display: 'flex',
    color: '#4a4a4a',
    paddingTop: theme.spacing(2),
  },
  DialogTitle: {
    backgroundColor: '#fff',
  },
  DialogContent: {
    backgroundColor: '#fff',
  },
  DialogAction: {
    backgroundColor: '#fff',
    justifyContent: 'center',
  },
  SendMessage: {
    marginLeft: 10,
  },
}));

function ResetPassword(props) {
  const { labelCancel = 'No', labelApprove = 'Yes', handleApprove, handleCancel, infos } = props;
  const { classes } = useStyles();
  const selectedDsp = useRecoilValue(selectedDps);
  const [password, setPassword] = useState(null);
  const [repeatPassword, setRepeatPassword] = useState(null);
  const [checked, setChecked] = useState(false);
  const msg = 'Send new password to driver ' + infos.name + ' via ' + infos.phoneNumber;

  function handleOnCancel(e) {
    handleCancel(e);
  }

  function handleOnApprove(e) {
    e.preventDefault();
    if (!repeatPassword || !password) {
      toast.error('Please fill all required fields');
      return false;
    }
    if (repeatPassword !== password) {
      toast.error('Password and confirm password not match');
      return false;
    }
    handleApprove(infos.username, password, checked);
  }

  function onchangePassword(e) {
    setPassword(e.target.value);
  }

  function onchangeResetPassword(e) {
    setRepeatPassword(e.target.value);
  }

  return (
    <Dialog open={true} onClose={handleOnCancel} aria-labelledby="form-dialog-title" œ maxWidth="md" fullWidth className={classes.Root}>
      <DialogTitle id="form-dialog-title" className={classes.DialogTitle}>
        <Typography variant="h" className={classes.Title}>
          Reset Driver Password
        </Typography>
      </DialogTitle>
      <DialogContent className={classes.DialogContent}>
        <Grid container spacing={3}>
          <Grid size={3}>
            <strong>ID</strong>
            <Typography>{infos.id}</Typography>
          </Grid>
          <Grid size={3}>
            <strong>Driver Name</strong>
            <Typography>{infos.name}</Typography>
          </Grid>
          <Grid size={3}>
            <strong>Username</strong>
            <Typography>{infos.username}</Typography>
          </Grid>
          <Grid size={3}>
            <strong>DSP</strong>
            <Typography>{selectedDsp.company}</Typography>
          </Grid>
          <InputField label="New Password" type="password" column="12" data-name="password" onChange={onchangePassword}></InputField>
          <InputField label="Confirm New Password" type="password" column="12" data-name="repeat_password" onChange={onchangeResetPassword}></InputField>
          <FormControlLabel
            control={
              <Checkbox
                name="send_to_phone_number"
                checked={checked}
                onChange={(e) => {
                  setChecked(e.target.checked);
                }}
              />
            }
            label={msg}
            className={classes.SendMessage}
          />
        </Grid>
      </DialogContent>
      <DialogActions className={classes.DialogAction}>
        <Button variant="outlined" color="primary" className={classes.CancelBtn} onClick={handleOnCancel}>
          {labelCancel}
        </Button>
        <Button variant="outlined" color="primary" className={classes.ApproveBtn} onClick={handleOnApprove}>
          RESET
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ResetPassword;
